import { init as sentryInit } from "@sentry/browser";
import { browserTracingIntegration } from "@sentry/browser";

export const init = () => {
  sentryInit({
    dsn: "https://2f6fc09d0448fddb3c470e956349b361@o4508091834236928.ingest.de.sentry.io/4508092891463760",
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
  });
};
